<template>
  <fragment>
    <default-header v-if="!showEnterManually" :h2="$t('batteryData.ScanQrCode')"></default-header>
    <default-header v-if="showEnterManually" :h2="$t('batteryData.batteryDetails')"></default-header>
    <back-btn :shouldShowModal="true"></back-btn>

    <div v-if="!showEnterManually" class="innerContent justifyContentFlexStart">
      <div class="camera-container text-center mb-2">
        <camera
          ref="camera"
          @sendPhoto="sendImageToBackend"
          @setLoading="showLoader = $event"
          :style="{display: showLoader ? 'none' : 'block'}"
          :from="'QRCODE'"
        ></camera>

        <preloader class="mt-4" v-if="showLoader" />
      </div>

      <p class="text-center text-uppercase">
        <span class="small">{{$t('batteryData.or')}}</span>
      </p>
      <div class="additionalPadding">
        <button class="btn btn-outline-primary w-100 mb-4" @click.stop="showEnterManuallyFunc">
          <font-awesome-icon :icon="['fas', 'keyboard']" :class="'mr-2'"></font-awesome-icon>
          {{$t('batteryData.manuallResult')}}
        </button>
      </div>
    </div>

    <div v-else class="innerContent">
      <div class="spaceBetween">
        <div class="additionalPadding pb-4">
          <div class="circle-background">
            <input-standard
              :label="$t('batteryData.ratedCca')"
              :name="'ratedCca'"
              :type="'number'"
              @changedValue="inputChangedValue"
              :error="currentTestResultErrors.ratedCca ? currentTestResultErrors.ratedCca[0] : false "
            />
            <div
              class="form-group small-label inputStandard"
              :style="{'margin-bottom': currentTestResultErrors.voltage ? '.2rem' : '1.1rem'}"
            >
              <label v-if="batteryDetails.voltage" for="voltage">{{ $t('batteryData.voltage') }}</label>
              <input
                :type="'number'"
                class="form-control"
                :name="'voltage'"
                :id="'voltage'"
                v-model="fValue"
                :aria-describedby="'voltage'"
                :placeholder="$t('batteryData.voltage')"
              />
              <span
                v-if="currentTestResultErrors.voltage"
                class="vv-error"
              >{{ currentTestResultErrors.voltage[0] }}</span>
            </div>

            <input-standard
              :label="$t('batteryData.measured')"
              :type="'number'"
              :name="'measuredCca'"
              @changedValue="inputChangedValue"
              :error="currentTestResultErrors.measuredCca ? currentTestResultErrors.measuredCca[0] : false"
            />
            <input-standard
              :label="$t('batteryData.temperature')"
              :type="'number'"
              :name="'temperature'"
              @changedValue="inputChangedValue"
              :error="currentTestResultErrors.temperature ? currentTestResultErrors.temperature[0] : false"
            />

            <select-standard
              :list="reserveHealthValues"
              :name="'reserveHealth'"
              :chosen="batteryDetails.reserveHealth"
              :label="$t('batteryData.reserveHealthLabel')"
              @selected="inputChangedValue"
            />
            <select-standard
              :list="crankingHealthValues"
              :name="'crankingHealth'"
              :chosen="batteryDetails.crankingHealth"
              :label="$t('batteryData.crankingHealthLabel')"
              @selected="inputChangedValue"
            />

            <select-standard
              :list="batteriesTypes"
              :name="'batteryType'"
              :chosen="batteryDetails.batteryType"
              :label="$t('batteryData.batteryType')"
              @selected="inputChangedValue"
              :error="currentTestResultErrors.batteryType ? currentTestResultErrors.batteryType[0] : false"
            />
            <select-standard
              :list="batteryDiagnosis"
              :name="'diagnosis'"
              :chosen="batteryDetails.diagnosis"
              :label="$t('batteryData.diagnosisBattery')"
              @selected="inputChangedValue"
              :error="currentTestResultErrors.diagnosis ? currentTestResultErrors.diagnosis[0] : false"
            />
          </div>
          <button
            v-if="showEnterManually"
            class="btn btn-primary mt-5 w-100 p-2 additionalMarginTop"
            @click.prevent="sendBatteryDetails"
          >{{$t('general.continue')}}</button>
        </div>
      </div>
    </div>
    <bottom-navigation></bottom-navigation>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { HTTP } from '../http';
import DefaultHeader from '../partials/DefaultHeader';
import BottomNavigation from '../partials/BottomNavigation';
import InputStandard from '../components/InputStandard';
import SelectStandard from '../components/SelectStandard';
import Camera from '../components/Camera';
import BackBtn from '../components/BackBtn';
import Preloader from '../components/Preloader';
export default {
  name: 'BatteryData',
  components: {
    DefaultHeader,
    BottomNavigation,
    InputStandard,
    SelectStandard,
    Camera,
    Preloader,
    BackBtn
  },
  data() {
    return {
      showLoader: false,
      value: '',
      showEnterManually: false,
      batteryDetails: {
        ratedCca: null,
        voltage: null,
        measuredCca: null,
        temperature: null,
        batteryType: null,
        reserveHealth: {
          value: '9',
          name: this.$t('batteryData.reserveHealthNotValid')
        },
        crankingHealth: {
          value: '99',
          name: this.$t('batteryData.crankingHealthNotValid')
        },
        diagnosis: null,
        vehicleId: null
      },
      lastVoltageValue: '',
      batteryDiagnosis: [
        {
          value: 0,
          name: this.$t('batteryData.diagnosisBad')
        },
        {
          value: 1,
          name: this.$t('batteryData.diagnosisAverage')
        },
        {
          value: 2,
          name: this.$t('batteryData.diagnosisGood')
        }
      ],
      reserveHealthValues: [
        {
          value: '9',
          name: this.$t('batteryData.reserveHealthNotValid')
        },
        {
          value: '0',
          name: this.$t('batteryData.reserveHealthGood')
        },
        {
          value: '1',
          name: this.$t('batteryData.reserveHealthPoor')
        }
      ],
      crankingHealthValues: [
        {
          value: '99',
          name: this.$t('batteryData.crankingHealthNotValid')
        },
        {
          value: '00',
          name: this.$t('batteryData.crankingHealthGood')
        },
        {
          value: '01',
          name: this.$t('batteryData.crankingHealthGoodNeedsRecharge')
        },
        {
          value: '05',
          name: this.$t('batteryData.crankingHealthEndOfLife')
        }
      ]
    };
  },
  beforeMount() {
    this.getConfigFromBackend();
  },
  mounted() {
    if (this.user.hasTester === 0) {
      this.showEnterManually = true;
    }

    $('.paddingToHide').css('padding-left', '0px');
    $('.paddingToHide').css('padding-right', '0px');
  },
  beforeDestroy() {
    $('.paddingToHide').css('padding-right', '15px');
    $('.paddingToHide').css('padding-left', '15px');
  },
  computed: {
    ...mapGetters({
      message: 'getMessage',
      user: 'getUser',
      currentVehicle: 'getCurrentVehicle',
      batteriesTypes: 'getBatteriesTypes',
      currentTestResultErrors: 'getCurrentTestResultErrors',
      testResultSuccess: 'getTestResultSuccess',
      config: 'getConfig',
      client: 'getCurrentClient'
    }),

    fValue: {
      get: function() {
        return this.batteryDetails.voltage;
      },
      set: function(newValue) {
        if (newValue.length > 2) {
          newValue = newValue.replace('.', '');
          this.batteryDetails.voltage =
            newValue.substr(0, newValue.length - 2) + '.' + newValue.substr(newValue.length - 2);
        } else {
          this.batteryDetails.voltage = newValue;
        }
        this.lastVoltageValue = this.batteryDetails.voltage;
      }
    }
  },

  methods: {
    ...mapActions(['getConfigFromBackend', 'sendBatteryData']),
    inputChangedValue(inputName, value) {
      this.batteryDetails[inputName] = value;
    },

    showEnterManuallyFunc() {
      this.showEnterManually = true;
    },

    sendImageToBackend(code) {
      let formData = new FormData();

      formData.append('code', code);
      formData.append('clientId', this.client.id);

      HTTP.post('/api/upload-qr-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          const overallDiagnosis = this.getOveralTestResult(response.data.test_result);

          this.showLoader = false;
          if (overallDiagnosis === 'error') {
            this.$toasted.show(this.$i18n.t('batteryData.resultNotRelevant'));
            return;
          }

          const testResult = {
            id: response.data.id,
            batteryType: response.data.battery_type,
            cca: response.data.cca_measured,
            ccaRated: response.data.cca_rated,
            ccaResult: overallDiagnosis,
            overallDiagnosis: overallDiagnosis,
            temperature: response.data.temperature_measured,
            crankingTestResult: response.data.cranking_test_result,
            crankingHealthResult: response.data.cranking_health_result,
            reserveHealthResult: response.data.reserve_health_result,
            temperatureResult: this.getTestResult(
              response.data.temperature_measured,
              response.data.temperature_rated_max,
              response.data.temperature_rated_min
            ),
            voltage: response.data.voltage,
            voltageResult: this.getTestResult(
              response.data.voltage,
              response.data.voltage_max,
              response.data.voltage_min
            )
          };

          this.$store.commit('SET_TEST_RESULT_SUCCESS', true);
          this.$store.commit('SET_CURRENT_TEST_RESULT', testResult);
          localStorage.setItem('exideTestedWithTester', true);
          this.$toasted.show(this.$i18n.t('QR code was validated properly'), {
            className: 'success'
          });
          this.$router.push({ name: 'Scan Plates' });
        })
        .catch(error => {
          this.showLoader = false;
          this.$toasted.show(this.$i18n.t('batteryData.qrCodeWasNotFound'));
        });
    },
    getTestResult(measured, max, min) {
      return (Number(measured) - Number(max)) * (Number(measured) - Number(min)) <= 0 ? 2 : 0;
    },
    getOveralTestResult(result) {
      switch (result) {
        case '00':
          return 2;
          break;
        case '-0':
          return 2;
          break;
        case '01':
          return 1;
          break;
        case '-1':
          return 1;
          break;
        case '05':
          return 0;
          break;
        case '-5':
          return 0;
          break;
        case '06':
          return 0;
          break;
        case '-6':
          return 0;
          break;

        default:
          return 'error';
          break;
      }
    },
    sendBatteryDetails() {
      this.batteryDetails['clientId'] = this.client.id;
      this.sendBatteryData(this.batteryDetails);
    }
  }
};
</script>
